import React, { useState, useEffect } from 'react';
import { Button, Box, IconButton, Drawer } from '@mui/material';
import { Sidebar, Menu, sidebarClasses, SubMenu } from 'react-pro-sidebar';
import { useAuth } from '../../../context/AuthProvider';
import Cookies from 'js-cookie';
import { myApi } from '../../../config/axiosConfig';

// ICONOS
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import LogoutIcon from '@mui/icons-material/Logout';
import HomeIcon from '@mui/icons-material/Home';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BadgeIcon from '@mui/icons-material/Badge';
import CampaignIcon from '@mui/icons-material/Campaign';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
//Javier T
import ReceiptIcon from '@mui/icons-material/Receipt';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import SummarizeIcon from '@mui/icons-material/Summarize';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import CalculateIcon from '@mui/icons-material/Calculate';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ShareLocationIcon from '@mui/icons-material/ShareLocation';
import Groups3Icon from '@mui/icons-material/Groups3';
import FlagIcon from '@mui/icons-material/Flag';
import TimelineIcon from '@mui/icons-material/Timeline';

// COMPONENTES
import Item from './componentes/Item';

const MainSideBar = () => {

    const { logOut } = useAuth();

    const [isColapse, setIsColapse] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [selected, setSelected] = useState('Dashboard');
    const [menu, setMenu] = useState([]);

    // ===============================================
    // VERIFICAR SI ES UN MOVIL
    // ===============================================

    const checkIsMobile = () => {

        setIsMobile(window.innerWidth < 768)

    }

    // ===============================================
    // CONTROLAR ESTADO DEL SIDEBAR PARA MOVIL
    // ===============================================

    const toggleSidebar = () => {

        setIsColapse(!isColapse);

    };

    const fetchMenu = async () => {
        //let cookie = Cookies.get('ebt_menu');
        let cookie = localStorage.getItem('ebt_menu');

        if (cookie) {
            let response = await myApi.post('/perfiles/decodeMenu', { menu: cookie })
            //destructuramos la respuesta para obtener el menu y el success
            const { data: { data: { menu }, success } } = response;
            if (success) {
                setMenu(menu)
            }
        }
    };

    useEffect(() => {

        fetchMenu();
    }, []);

    // ===============================================
    // USE EFFECT PARA VALIDAR MOVIL
    // ===============================================

    useEffect(() => {

        checkIsMobile();
        window.addEventListener('resize', checkIsMobile);

        // LIMPIAMOS EL USEFFECT
        return () => {

            window.removeEventListener('resize', checkIsMobile);

        }

    }, []);

    // ===============================================

    const iconMap = {
        HomeIcon: <HomeIcon />,
        BadgeIcon: <BadgeIcon />,
        AccountCircleIcon: <AccountCircleIcon />,
        CampaignIcon: <CampaignIcon />,
        MonitorHeartIcon: <MonitorHeartIcon />,
        ReportProblemIcon: <ReportProblemIcon />,
        UploadFileIcon: <UploadFileIcon />,
        LocalGasStationIcon: <LocalGasStationIcon />,
        SummarizeIcon: <SummarizeIcon />,
        DashboardIcon: <DashboardIcon />,
        ReceiptIcon: <ReceiptIcon />,
        ReportProblemIcon: <ReportProblemIcon />,
        LocationOnIcon: <LocationOnIcon />,
        AgricultureIcon: <AgricultureIcon />,
        LocalShippingIcon: <LocalShippingIcon />,
        PermContactCalendarIcon: <PermContactCalendarIcon />,
        MonetizationOnIcon: <MonetizationOnIcon />,
        CalculateIcon: <CalculateIcon />,
        AssessmentIcon: <AssessmentIcon />,
        ShareLocationIcon: <ShareLocationIcon />,
        Groups3Icon: <Groups3Icon />,
        FlagIcon: <FlagIcon />,
        TimelineIcon: <TimelineIcon />,
    };

    const agruparModulos = (arrMenu) => {
        const moduloMap = {};

        arrMenu
            .filter((modulo) => Number(modulo.id_modulo) !== 9)
            .forEach((modulo) => {
            if (!moduloMap[modulo.id_modulo]) {
                // Si el módulo no existe en el mapa, lo añadimos
                moduloMap[modulo.id_modulo] = {
                    ...modulo,
                    submodulos: [...modulo.submodulos] // Copia los submódulos
                };
            } else {
                // Si el módulo ya existe, agregamos los submódulos sin duplicarlos
                const submodulosExistentes = moduloMap[modulo.id_modulo].submodulos.map(s => s.id_submodulo);

                modulo.submodulos.forEach(sub => {
                    if (!submodulosExistentes.includes(sub.id_submodulo)) {
                        moduloMap[modulo.id_modulo].submodulos.push(sub);
                    }
                });
            }
        });

        return Object.values(moduloMap);
    };

    const generarMenuItems = (arrMenu, selected, setSelected) => {

        const menuOrdenado = [...arrMenu].sort((a, b) =>
            a.nombre_modulo.localeCompare(b.nombre_modulo, 'es', { sensitivity: 'base' })
        );
        return menuOrdenado.map((item, index) => {
            if (item.submodulos && item.submodulos.length > 0) {

                const submodulosOrdenados = [...item.submodulos].sort((a, b) =>
                    a.nombre_submodulo.localeCompare(b.nombre_submodulo, 'es', { sensitivity: 'base' })
                );

                return (
                    <SubMenu
                        title={item.nombre_modulo}
                        label={item.nombre_modulo}
                        icon={iconMap[item.icono_modulo]}
                        key={index}
                    >
                        {submodulosOrdenados.map((subItem, subIndex) => (
                            <Item
                                title={subItem.nombre_submodulo}
                                to={subItem.url_submodulo}
                                icon={iconMap[subItem.icono_submodulo]}
                                selected={selected}
                                setSelected={setSelected}
                                key={`${index}-${subIndex}`}
                            />
                        ))}
                    </SubMenu>
                );
            }

            return (
                <Item
                    title={item.nombre_modulo}
                    to={item.url_modulo}
                    icon={iconMap[item.icono_modulo]}
                    selected={selected}
                    setSelected={setSelected}
                    key={index}
                />
            );
        });
    };

    // Uso de la función con la agrupación previa
    const menuAgrupado = agruparModulos(menu);
    const menuItems = generarMenuItems(menuAgrupado, selected, setSelected);

    let perfil = Cookies.get('ebt_perfil');

    return (

        <Box>

            {
                isMobile ? (

                    // BOTON PARA ABRIR SIDE BAR DESDE MOVIL

                    <IconButton
                        sx={{
                            zIndex: 1,
                            position: "absolute",
                            top: "20px",
                            left: "20px",
                            color: 'blue',
                        }}
                        onClick={toggleSidebar}
                    >
                        <MenuOutlinedIcon />
                    </IconButton>

                ) : (

                    // SIDE BAR PARA ESCRITORIO

                    <Sidebar
                        collapsed={isColapse}
                        rootStyles={{
                            [`.${sidebarClasses.container}`]: {
                                backgroundColor: 'white',
                                height: '100vh',
                                display: 'flex',
                                flexDirection: 'column'
                            },
                        }}
                    >
                        {/* BODY DEL SIDEBAR */}
                        <Box
                            sx={{
                                flex: 1,
                                overflowY: 'auto'
                            }}
                        >
                            <Box sx={{
                                display: 'flex',
                                justifyContent: isColapse ? 'center' : 'end',
                                padding: 1
                            }}>
                                <Button onClick={() => setIsColapse(!isColapse)}>
                                    <MenuOutlinedIcon />
                                </Button>
                            </Box>

                            <Menu>
                                
{/*                                 
                                <Item
                                    title="Dashboard"
                                    to="/dashboard"
                                    icon={<HomeIcon />}
                                    selected={selected}
                                    setSelected={setSelected}
                                />
                                <Item
                                    title="Carga de Diesel"
                                    to="/diesel/fuelgeneralView"
                                    icon={<LocalGasStationIcon />}
                                    selected={selected}
                                    setSelected={setSelected}
                                />
                                <Item
                                    title="Menu Operadores"
                                    to="/menuOperadores"
                                    icon={<LocalGasStationIcon />}
                                    selected={selected}
                                    setSelected={setSelected}
                                />
                                <Item
                                    title="Inspecciones"
                                    to="/inspecciones"
                                    icon={<LocalGasStationIcon />}
                                    selected={selected}
                                    setSelected={setSelected}
                                /> */}
                                {/* Mostrar solo si perfil == 1 */}
                                {perfil === "1" && (
                                    <>
                                        <Item
                                            title="Dashboard"
                                            to="/dashboard"
                                            icon={<HomeIcon />}
                                            selected={selected}
                                            setSelected={setSelected}
                                        />
                                        {/* <Item
                                            title="Carga de Diesel"
                                            to="/diesel/fuelgeneralView"
                                            icon={<LocalGasStationIcon />}
                                            selected={selected}
                                            setSelected={setSelected}
                                        /> */}
                                        <Item
                                            title="Menu Operadores"
                                            to="/menuOperadores"
                                            icon={<LocalGasStationIcon />}
                                            selected={selected}
                                            setSelected={setSelected}
                                        />
                                        <Item
                                            title="Inspecciones"
                                            to="/inspecciones"
                                            icon={<LocalGasStationIcon />}
                                            selected={selected}
                                            setSelected={setSelected}
                                        />
                                    </>
                                )}
                                {generarMenuItems(menuAgrupado, selected, setSelected)}
                            </Menu>
                        </Box>

                        {/* FOOTER DEL SIDEBAR */}
                        <Box
                            sx={{
                                height: '10vh',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                backgroundColor: '#abb2b9'
                            }}
                        >
                            <IconButton
                                sx={{ color: 'white' }}
                                onClick={logOut}
                            >
                                <LogoutIcon />
                            </IconButton>
                        </Box>
                    </Sidebar>

                )

            }

            {/* SIDE BAR PARA MOVIL */}

            {isMobile && (
                <Drawer
                    anchor='left'
                    open={isColapse}
                    onClose={toggleSidebar}
                    variant='temporary'
                >
                    <Sidebar
                        collapsed={isColapse}
                        rootStyles={{
                            [`.${sidebarClasses.container}`]: {
                                backgroundColor: 'white',
                                height: '100vh',
                                display: 'flex',
                                flexDirection: 'column'
                            },
                        }}
                    >
                        {/* BODY DEL SIDEBAR */}
                        <Box
                            sx={{
                                flex: 1,           // 👈 ocupa todo el espacio disponible
                                overflowY: 'auto'  // 👈 scroll independiente para los menús
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: isColapse ? 'center' : 'end',
                                    padding: 1
                                }}
                            >
                                <Button onClick={() => setIsColapse(!isColapse)}>
                                    <MenuOutlinedIcon />
                                </Button>
                            </Box>

                            <Menu>
                                <Item
                                    title="Dashboard"
                                    to="/dashboard"
                                    icon={<HomeIcon />}
                                    selected={selected}
                                    setSelected={setSelected}
                                />
                                {/* <Item
                                    title="Carga de Diesel"
                                    to="/diesel/fuelgeneralView"
                                    icon={<LocalGasStationIcon />}
                                    selected={selected}
                                    setSelected={setSelected}
                                /> */}
                                {generarMenuItems(menuAgrupado, selected, setSelected)}
                            </Menu>
                        </Box>

                        {/* FOOTER DEL SIDEBAR */}
                        <Box
                            sx={{
                                height: '10vh',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                backgroundColor: '#abb2b9'
                            }}
                        >
                            <IconButton
                                sx={{ color: 'white' }}
                                onClick={logOut}
                            >
                                <LogoutIcon />
                            </IconButton>
                        </Box>
                    </Sidebar>
                </Drawer>
            )}

        </Box>

    )

}

export default MainSideBar